export const signmeRegisterFormStructure = [
  {
    element: 'TextInput',
    label: 'address_dialog_firstName',
    id: 'firstName',
    layoutSize: 6
  },
  {
    element: 'TextInput',
    label: 'address_dialog_lastName',
    id: 'lastName',
    layoutSize: 6
  },
  {
    element: 'MobileSplitNumber',
    label: 'address_dialog_phone',
    id: 'phone',
    layoutSize: 6
  },
  {
    element: 'TextInput',
    label: 'address_dialog_email',
    id: 'email',
    validationRule: 'EMAIL',
    layoutSize: 6
  }
];
